// Configuration for different environments
const IMAGE_CONFIG = {
  development: {
    reviewsMediaUrl: 'https://reviews-media.s3.il-central-1.amazonaws.com',
    productImagesUrl: 'https://images.pricedrop.co.il',
  },
  production: {
    reviewsMediaUrl: 'https://reviews-media.pricedrop.co.il',
    productImagesUrl: 'https://images.pricedrop.co.il',
  },
};

function getConfig() {
  return IMAGE_CONFIG.production;
  // return import.meta.env.DEV ? IMAGE_CONFIG.development : IMAGE_CONFIG.production;
}

/**
 * Generate URL for review media images
 * @param key - The S3 object key or filename
 * @returns Full URL to the image
 */
export function getReviewImageUrl(key: string): string {
  if (!key || typeof key !== 'string') {
    console.warn('getReviewImageUrl received invalid key:', key);
    return '';
  }

  const config = getConfig();
  return `${config.reviewsMediaUrl}/${key}`;
}

/**
 * Generate URL for product images
 * @param key - The image key or filename
 * @returns Full URL to the image
 */
export function getProductImageUrl(key: string): string {
  if (!key || typeof key !== 'string') {
    console.warn('getProductImageUrl received invalid key:', key);
    return '';
  }

  const config = getConfig();
  return `${config.productImagesUrl}/${key}`;
}
